/* NUARIVA theme behaviour — replaces the DC/React runtime of the source HTML. */
(function () {
  'use strict';
  var R = window.NuarivaRoutes || { cartAdd: '/cart/add.js', cart: '/cart', cartJs: '/cart.js', search: '/search/suggest.json', root: '/' };
  var reduced = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  function $(s, c) { return (c || document).querySelector(s); }
  function $$(s, c) { return Array.prototype.slice.call((c || document).querySelectorAll(s)); }

  function formatMoney(cents) {
    var fmt = window.NuarivaMoney || '{{amount_with_comma_separator}} €';
    if (!formatMoney._t) formatMoney._t = document.createElement('textarea');
    formatMoney._t.innerHTML = String(fmt).replace(/<[^>]*>/g, '');
    fmt = formatMoney._t.value;
    var n = (cents / 100);
    function d(num, prec, th, dec) {
      var p = num.toFixed(prec).split('.');
      var i = p[0].replace(/\B(?=(\d{3})+(?!\d))/g, th);
      return i + (p[1] ? dec + p[1] : '');
    }
    return fmt.replace(/\{\{\s*(\w+)\s*\}\}/, function (_, k) {
      switch (k) {
        case 'amount': return d(n, 2, ',', '.');
        case 'amount_no_decimals': return d(n, 0, ',', '.');
        case 'amount_with_comma_separator': return d(n, 2, '.', ',');
        case 'amount_no_decimals_with_comma_separator': return d(n, 0, '.', ',');
        case 'amount_with_apostrophe_separator': return d(n, 2, "'", '.');
        case 'amount_with_period_and_space_separator': return d(n, 2, ' ', '.');
        case 'amount_with_space_separator': return d(n, 2, ' ', ',');
        default: return d(n, 2, '.', ',');
      }
    });
  }

  /* ---------- Announcement rotator ---------- */
  $$('[data-nua-rotator]').forEach(function (el) {
    var msgs = $$('[data-msg]', el);
    if (msgs.length < 2) return;
    var i = 0;
    setInterval(function () {
      msgs[i].classList.remove('is-active');
      i = (i + 1) % msgs.length;
      msgs[i].classList.add('is-active');
    }, parseInt(el.getAttribute('data-interval'), 10) || 5000);
  });

  /* ---------- Header: search / bag / mobile menu ---------- */
  function closePanels(except) {
    $$('[data-nua-panel]').forEach(function (p) {
      if (p.getAttribute('data-nua-panel') === except) return;
      p.hidden = true;
      var b = $('[data-nua-toggle="' + p.getAttribute('data-nua-panel') + '"]');
      if (b) b.setAttribute('aria-expanded', 'false');
    });
  }
  $$('[data-nua-toggle]').forEach(function (btn) {
    btn.addEventListener('click', function () {
      var key = btn.getAttribute('data-nua-toggle');
      var panel = $('[data-nua-panel="' + key + '"]');
      if (!panel) return;
      var open = panel.hidden;
      closePanels(key);
      panel.hidden = !open;
      btn.setAttribute('aria-expanded', open ? 'true' : 'false');
      if (open && key === 'search') { var inp = $('[data-nua-search-input]'); if (inp) setTimeout(function () { inp.focus(); }, 0); }
      if (open && key === 'bag') refreshBag();
    });
  });
  $$('[data-nua-close-panels]').forEach(function (a) { a.addEventListener('click', function () { closePanels(); }); });

  var menu = $('[data-nua-menu]');
  var menuBtn = $('[data-nua-menu-open]');
  function setMenu(open) {
    if (!menu) return;
    menu.hidden = !open;
    if (menuBtn) menuBtn.setAttribute('aria-expanded', open ? 'true' : 'false');
    document.documentElement.style.overflow = open ? 'hidden' : '';
    if (open) { var c = $('[data-nua-menu-close]', menu); if (c) setTimeout(function () { c.focus(); }, 0); }
    else if (menuBtn) menuBtn.focus();
    updateSticky();
  }
  if (menuBtn) menuBtn.addEventListener('click', function () { setMenu(true); });
  $$('[data-nua-menu-close]').forEach(function (b) { b.addEventListener('click', function () { setMenu(false); }); });

  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Escape') return;
    if (menu && !menu.hidden) return setMenu(false);
    var guide = $('[data-nua-guide]'); if (guide && !guide.hidden) { guide.hidden = true; return; }
    var zoom = $('[data-nua-zoom-dlg]'); if (zoom && !zoom.hidden) { zoom.hidden = true; return; }
    closePanels();
  });

  /* Predictive search (Shopify /search/suggest.json) */
  var sInput = $('[data-nua-search-input]');
  if (sInput) {
    var sList = $('[data-nua-search-results]'), sEmpty = $('[data-nua-search-empty]'), sTimer, sCtrl;
    sInput.addEventListener('input', function () {
      clearTimeout(sTimer);
      var q = sInput.value.trim();
      if (q.length < 2) { sList.innerHTML = ''; sEmpty.hidden = true; return; }
      sTimer = setTimeout(function () {
        if (sCtrl) sCtrl.abort();
        sCtrl = window.AbortController ? new AbortController() : null;
        fetch(R.search + '?q=' + encodeURIComponent(q) + '&resources[type]=product&resources[limit]=6', sCtrl ? { signal: sCtrl.signal } : {})
          .then(function (r) { return r.json(); })
          .then(function (data) {
            var items = (data.resources && data.resources.results && data.resources.results.products) || [];
            sList.innerHTML = '';
            items.forEach(function (p) {
              var li = document.createElement('li');
              var a = document.createElement('a'); a.href = p.url;
              if (p.image) { var img = document.createElement('img'); img.src = p.image + (p.image.indexOf('?') > -1 ? '&' : '?') + 'width=120'; img.alt = ''; img.width = 60; img.height = 60; img.loading = 'lazy'; a.appendChild(img); }
              var wrap = document.createElement('span');
              var n = document.createElement('span'); n.className = 'n'; n.textContent = String(p.title).replace(/^\s*n(?:au|ua)riva\s*[-–]\s*/i, '');
              var pr = document.createElement('span'); pr.className = 'p'; pr.textContent = formatMoney(Math.round(parseFloat(p.price) * 100));
              wrap.appendChild(n); wrap.appendChild(pr); a.appendChild(wrap); li.appendChild(a); sList.appendChild(li);
            });
            sEmpty.hidden = items.length > 0;
          }).catch(function () {});
      }, 200);
    });
  }

  /* Bag */
  function setCount(n) { $$('[data-nua-cart-count]').forEach(function (el) { el.textContent = n; }); }
  function esc(s) { var d = document.createElement('div'); d.textContent = s == null ? '' : String(s); return d.innerHTML; }
  function refreshBag() {
    return fetch(R.cartJs, { headers: { Accept: 'application/json' } }).then(function (r) { return r.json(); }).then(function (cart) {
      setCount(cart.item_count);
      var body = $('[data-nua-bag-body]');
      if (!body) return cart;
      if (!cart.item_count) return cart;
      var html = '<p class="nua-bag-title">Tu carrito (' + cart.item_count + ')</p><ul class="nua-bag-lines">';
      cart.items.slice(0, 4).forEach(function (it) {
        html += '<li>' + (it.image ? '<img src="' + esc(it.image) + (it.image.indexOf('?') > -1 ? '&' : '?') + 'width=120" alt="" width="44" height="44">' : '') +
          '<span><strong>' + esc(String(it.product_title).replace(/^\s*n(?:au|ua)riva\s*[-–]\s*/i, '')) + '</strong>' + (it.variant_title ? ' · ' + esc(it.variant_title) : '') + ' × ' + it.quantity + '</span></li>';
      });
      html += '</ul><p class="nua-bag-text"><strong>Total: ' + formatMoney(cart.total_price) + '</strong></p><a href="' + R.cart + '" class="nua-btn nua-btn--plum">Ver carrito</a>';
      body.innerHTML = html;
      return cart;
    }).catch(function () {});
  }

  /* ---------- Carousels ---------- */
  $$('[data-nua-carousel]').forEach(function (root) {
    var track = $('[data-track]', root); if (!track) return;
    var idx = 0, paused = false;
    function per() { var w = window.innerWidth, p = parseInt(track.getAttribute('data-per'), 10) || 4; return w >= 1000 ? p : w >= 700 ? 2 : 1; }
    function move(d) {
      var total = track.children.length, max = Math.max(0, total - per());
      idx = (idx + d) > max ? 0 : Math.max(0, idx + d);
      track.style.setProperty('--idx', idx);
    }
    $$('[data-dir]', root).forEach(function (b) { b.addEventListener('click', function () { move(parseInt(b.getAttribute('data-dir'), 10)); }); });
    var wrap = track.parentNode;
    ['mouseenter', 'focusin'].forEach(function (ev) { wrap.addEventListener(ev, function () { paused = true; }); });
    ['mouseleave', 'focusout'].forEach(function (ev) { wrap.addEventListener(ev, function () { paused = false; }); });
    window.addEventListener('resize', function () { move(0); });
    if (!reduced) setInterval(function () { if (!paused && !document.hidden) move(1); }, parseInt(root.getAttribute('data-interval'), 10) || 5000);
  });

  /* ---------- Shop filters ---------- */
  $$('[data-nua-filter]').forEach(function (root) {
    var pills = $$('[data-filter]', root);
    pills.forEach(function (p) {
      p.addEventListener('click', function () {
        var f = p.getAttribute('data-filter');
        pills.forEach(function (x) { x.setAttribute('aria-pressed', x === p ? 'true' : 'false'); });
        $$('.nua-grid > li', root).forEach(function (li) {
          var cats = (li.getAttribute('data-cats') || '').split(' ');
          li.hidden = !(f === '*' || cats.indexOf(f) > -1);
        });
      });
    });
  });

  /* ---------- Accordions (FAQ / info) — one open at a time, like the source ---------- */
  $$('[data-nua-accordion]').forEach(function (root) {
    var btns = $$('.nua-acc__btn', root);
    btns.forEach(function (b) {
      b.addEventListener('click', function () {
        var open = b.getAttribute('aria-expanded') === 'true';
        btns.forEach(function (o) { o.setAttribute('aria-expanded', 'false'); var p = document.getElementById(o.getAttribute('aria-controls')); if (p) p.hidden = true; });
        if (!open) { b.setAttribute('aria-expanded', 'true'); var p = document.getElementById(b.getAttribute('aria-controls')); if (p) p.hidden = false; }
      });
    });
  });

  /* ---------- Newsletter client-side validation (Shopify customer form) ---------- */
  var nf = $('#nua-news-form');
  if (nf) nf.addEventListener('submit', function (e) {
    var inp = $('[data-nua-email]', nf), msg = $('[data-nua-news-msg]', nf);
    if (!/^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/.test(inp.value.trim())) {
      e.preventDefault(); inp.setAttribute('aria-invalid', 'true');
      msg.textContent = 'Introduce un correo válido, por ejemplo nombre@ejemplo.com.';
    }
  });

  /* ---------- Sticky mobile CTAs ---------- */
  var stickyHome = $('[data-nua-sticky-home]'), stickyPdp = $('[data-nua-sticky-pdp]'), heroCta = $('[data-nua-hero-cta]');
  function updateSticky() {
    var narrow = window.innerWidth < 960;
    if (stickyHome) {
      var past = heroCta ? heroCta.getBoundingClientRect().bottom < 0 : window.scrollY > 600;
      stickyHome.hidden = !(past && narrow && (!menu || menu.hidden));
    }
    if (stickyPdp) stickyPdp.hidden = !(window.scrollY > 700 && narrow);
  }
  window.addEventListener('scroll', updateSticky, { passive: true });
  window.addEventListener('resize', updateSticky);
  updateSticky();

  /* ---------- PDP ---------- */
  $$('[data-nua-product]').forEach(function (root) {
    var sid = root.getAttribute('data-section');
    var jsonEl = document.querySelector('[data-nua-product-json="' + sid + '"]');
    if (!jsonEl) return;
    var data = JSON.parse(jsonEl.textContent);
    var lowT = parseInt(root.getAttribute('data-low-stock'), 10) || 10;
    var form = $('[data-nua-form]', root) || $('form[action*="/cart/add"]', root);
    var idInput = $('[data-nua-variant-id]', root);
    var qtyInput = $('[data-nua-qty-input]', root), qtyOut = $('[data-nua-qty-value]', root);
    var atc = $('[data-nua-atc]', root), msg = $('[data-nua-atc-msg]', root);
    var qty = 1;

    /* Gallery */
    var slides = $$('.nua-gallery__slide', root), thumbs = $$('[data-nua-thumb]', root), label = $('[data-nua-shot-label]', root);
    var shot = Math.max(0, slides.findIndex(function (s) { return s.classList.contains('is-active'); }));
    function show(i) {
      if (!slides.length) return;
      shot = (i + slides.length) % slides.length;
      slides.forEach(function (s, k) {
        s.classList.toggle('is-active', k === shot);
        var v = s.querySelector('video'); if (v && k !== shot) v.pause();
      });
      thumbs.forEach(function (t, k) { t.setAttribute('aria-pressed', k === shot ? 'true' : 'false'); });
      if (label) label.textContent = (shot + 1) + ' / ' + slides.length;
    }
    $$('[data-nua-shot]', root).forEach(function (b) { b.addEventListener('click', function () { show(shot + parseInt(b.getAttribute('data-nua-shot'), 10)); }); });
    thumbs.forEach(function (t) { t.addEventListener('click', function () { show(parseInt(t.getAttribute('data-nua-thumb'), 10)); }); });

    /* Zoom */
    var zdlg = document.querySelector('[data-nua-zoom-dlg]'), zimg = document.querySelector('[data-nua-zoom-img]');
    $$('[data-nua-zoom]', root).forEach(function (z) {
      z.addEventListener('click', function () { if (!zdlg) return; zimg.src = z.getAttribute('data-nua-zoom'); zdlg.hidden = false; $('[data-nua-zoom-close]', zdlg).focus(); });
    });
    if (zdlg) zdlg.addEventListener('click', function (e) { if (e.target === zdlg || e.target.hasAttribute('data-nua-zoom-close')) zdlg.hidden = true; });

    /* Variant selection */
    var optGroups = $$('[data-nua-option]', root);
    function selected() { return optGroups.map(function (g) { var b = $('[aria-pressed="true"]', g); return b ? b.getAttribute('data-value') : null; }); }
    function findVariant(opts) {
      return data.variants.find(function (v) { return v.options.every(function (o, i) { return opts[i] == null || o === opts[i]; }); });
    }
    var current = data.variants.find(function (v) { return String(v.id) === idInput.value; }) || data.variants[0];

    function markAvailability() {
      var sel = selected();
      optGroups.forEach(function (g, gi) {
        $$('[data-value]', g).forEach(function (b) {
          var test = sel.slice(); test[gi] = b.getAttribute('data-value');
          var v = findVariant(test);
          b.classList.toggle('is-unavailable', !v || !v.available);
        });
      });
    }
    function render() {
      var v = current;
      var total = v ? v.price * qty : 0;
      $('[data-nua-price]', root).textContent = v ? formatMoney(v.price) : '';
      var cmp = $('[data-nua-compare]', root), off = $('[data-nua-off]', root);
      if (v && v.compare > v.price) {
        cmp.hidden = false; cmp.textContent = formatMoney(v.compare);
        off.hidden = false; off.textContent = '-' + Math.round((1 - v.price / v.compare) * 100) + ' %';
      } else { cmp.hidden = true; off.hidden = true; }
      var stock = $('[data-nua-stock]', root);
      if (!v || !v.available) { stock.setAttribute('data-state', 'out'); stock.textContent = data.stock.out; }
      else if (v.managed === 'shopify' && v.policy === 'deny' && v.qty <= lowT) { stock.setAttribute('data-state', 'low'); stock.textContent = data.stock.low; }
      else { stock.setAttribute('data-state', 'in'); stock.textContent = data.stock['in']; }
      if (!v) { atc.disabled = true; atc.textContent = data.unavailableLabel; }
      else if (!v.available) { atc.disabled = true; atc.textContent = data.soldoutLabel; }
      else { atc.disabled = false; atc.innerHTML = esc(data.atcLabel) + ' · <span data-nua-total>' + esc(formatMoney(total)) + '</span>'; }
      var sb = $('[data-nua-sticky-add]'); if (sb) sb.disabled = !v || !v.available;
      var sl = $('[data-nua-sticky-label]'); if (sl) sl.textContent = data.title + (v && v.title !== 'Default Title' ? ' · ' + v.title : '');
      optGroups.forEach(function (g) { var b = $('[aria-pressed="true"]', g), out = $('[data-nua-opt-value]', g); if (b && out) out.textContent = b.getAttribute('data-value'); });
      if (v) idInput.value = v.id;
      qtyOut.textContent = qty; qtyInput.value = qty;
      markAvailability();
    }
    optGroups.forEach(function (g) {
      $$('[data-value]', g).forEach(function (b) {
        b.addEventListener('click', function () {
          $$('[data-value]', g).forEach(function (x) { x.setAttribute('aria-pressed', x === b ? 'true' : 'false'); });
          current = findVariant(selected());
          msg.textContent = '';
          if (current && current.media) {
            var i = slides.findIndex(function (s) { return s.getAttribute('data-media-id') === String(current.media); });
            if (i > -1) show(i);
          }
          if (current && window.history && history.replaceState) {
            var u = new URL(window.location.href); u.searchParams.set('variant', current.id); history.replaceState({}, '', u.toString());
          }
          render();
        });
      });
    });
    $$('[data-nua-qty]', root).forEach(function (b) {
      b.addEventListener('click', function () { qty = Math.min(10, Math.max(1, qty + parseInt(b.getAttribute('data-nua-qty'), 10))); msg.textContent = ''; render(); });
    });

    function add() {
      if (!current || !current.available) { msg.textContent = 'Elige una combinación disponible antes de continuar.'; return; }
      atc.disabled = true;
      fetch(R.cartAdd, { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ items: [{ id: current.id, quantity: qty }] }) })
        .then(function (r) { return r.json().then(function (j) { return { ok: r.ok, j: j }; }); })
        .then(function (res) {
          if (!res.ok) { msg.textContent = res.j.description || res.j.message || 'No se pudo añadir al carrito.'; return; }
          msg.innerHTML = 'Añadido al carrito. <a href="' + R.cart + '">Ver carrito</a>';
          refreshBag();
        })
        .catch(function () { form.submit(); })
        .then(function () { atc.disabled = !current || !current.available; });
    }
    if (form) form.addEventListener('submit', function (e) { e.preventDefault(); add(); });
    var sb = document.querySelector('[data-nua-sticky-add]'); if (sb) sb.addEventListener('click', add);

    /* Size guide */
    var guide = document.querySelector('[data-nua-guide]');
    $$('[data-nua-guide-open]', root).forEach(function (b) { b.addEventListener('click', function () { if (guide) { guide.hidden = false; var c = $('[data-nua-guide-close]', guide); if (c) c.focus(); } }); });
    if (guide) guide.addEventListener('click', function (e) { if (e.target === guide || e.target.hasAttribute('data-nua-guide-close')) guide.hidden = true; });

    render();
  });
})();
